import React from 'react';

const ActiveFilters = ({ 
  showTodayOnly, 
  showTodayFollowUpOnly, 
  selectedFilters, 
  onToggleTodayOnly, 
  onToggleFollowUpOnly,
  onFilterChange,
  onClearAll 
}) => {
  const hasActiveFilters = showTodayOnly || showTodayFollowUpOnly || 
    selectedFilters.location || selectedFilters.branch || 
    selectedFilters.courseType || selectedFilters.courseName || 
    selectedFilters.enrollment_status || selectedFilters.source;

  if (!hasActiveFilters) return null;

  return (
    <div className="active-filters">
      <p>Active Filters:</p>

      {showTodayOnly && (
        <span className="filter-badge">
          Today's Register
          <button onClick={onToggleTodayOnly} className="filter-remove">×</button>
        </span>
      )}

      {showTodayFollowUpOnly && (
        <span className="filter-badge">
          Today's Follow-Up
          <button onClick={onToggleFollowUpOnly} className="filter-remove">×</button>
        </span>
      )}

      {selectedFilters.branch && (
        <span className="filter-badge">
          Branch: {selectedFilters.branch}
          <button onClick={() => onFilterChange('branch', '')} className="filter-remove">×</button>
        </span>
      )}

      {selectedFilters.courseType && (
        <span className="filter-badge">
          Course Type: {selectedFilters.courseType}
          <button onClick={() => onFilterChange('courseType', '')} className="filter-remove">×</button>
        </span>
      )}

      {selectedFilters.courseName && (
        <span className="filter-badge">
          Course Name: {selectedFilters.courseName}
          <button onClick={() => onFilterChange('courseName', '')} className="filter-remove">×</button>
        </span>
      )}

      {selectedFilters.enrollment_status && (
        <span className="filter-badge">
          Enrollment Status: {selectedFilters.enrollment_status}
          <button onClick={() => onFilterChange('enrollment_status', '')} className="filter-remove">×</button>
        </span>
      )}

      {selectedFilters.source && (
        <span className="filter-badge">
          Source: {selectedFilters.source}
          <button onClick={() => onFilterChange('source', '')} className="filter-remove">×</button>
        </span>
      )}

      <button onClick={onClearAll} className="clear-all-filters">Clear All</button>
    </div>
  );
};

export default ActiveFilters;
